import Vue from "vue";
import Router from "vue-router";
import TimestampPage from "./views/TimestampPage.vue";
import JsonPage from "./views/JsonPage.vue";
import TranslatePage from "./views/TranslatePage.vue";
import Base64ImagePage from "./views/Base64ImagePage.vue";

Vue.use(Router);

export default new Router({
  mode: "hash",
  routes: [
    {
      path: "/",
      name: "timestamp",
      component: TimestampPage,
    },
    {
      path: "/json",
      name: "json",
      component: JsonPage,
    },
    {
      path: "/translate",
      name: "translate",
      component: TranslatePage,
    },
    {
      path: "/base64-image",
      name: "base64Image",
      component: Base64ImagePage,
    },
  ],
});
